import { API_AUTH, API_AUTHDEMO, setTokenGlobal, setTokenForAUTHDEMO } from "../common";
import { Cookies } from "react-cookie";
import { getDomain, getDomainUrlDemo } from "utils/utils";

var urlNew = getDomain();
const cookies = new Cookies();
var token = cookies.get("userTokenDaiLy");
if (typeof token != "undefined" && token.length > 6) {
  token = token.substring(6);
  setTokenGlobal(token, urlNew);
}
var urlDemoNew = getDomainUrlDemo();
if (typeof token != "undefined" && token.length > 6) {
  setTokenForAUTHDEMO(token, urlDemoNew);
}
const PhanQuyenApi = {
  phanQuyen: (ugroupId) => {
    return API_AUTH.get(`Role/GetRolesByUGroupId?ugroupId=${ugroupId}`, {});
  },
  chiTietTaiKhoan: (userId) => {
    return API_AUTH.get(`users/GetFullUserByUserId?userId=${userId}`, {});
  },
  menuLeft: (sUserName) => {
    return API_AUTH.get(
      `users/GetFullUserByUserName?sUserName=${sUserName}`,
      {}
    );
  },
  getAvatar: (sUserName) => {
    return API_AUTH.get(`users/GetAvatarByUserName?sUserName=${sUserName}`, {});
  },
  //  addPhanQuyen: (params) => API_AUTH.post("phanquyen/saveRoleInUser", params),
  addPhanQuyen: (userId, lstRoleId) =>
    API_AUTH.post(
      `users/UpdateUserRole?userId=${userId}&lstRoleId=${lstRoleId}`,
      {}
    ),
  addPhanQuyen1: (userInRole) => API_AUTH.post(`users/UpdateUserRole1`, userInRole),

  getAllRoles: () => {
    return API_AUTH.get(`Role/GetAllRoles`, {});
  },

  getAllRolesDemo: () => {
    return API_AUTHDEMO.get(`Role/GetAllRoles`, {});
  },

  InsertRoles: (params) => API_AUTH.post("Role/InsertRoles", params),

  UpdateRoleBy: (userName, params) =>
    API_AUTH.post(`Role/UpdateRoleById?userName=${userName}`, params),

  DeleteRole: (RoleID, userName) =>
    API_AUTH.delete(
      `Role/DeleteRoleById?id=${RoleID}&userName=${userName}`,
      {}
    ),

  DeleteData: (userName, BranchID) =>
    API_AUTH.post(
      `Role/xoaDuLieuCu?userName=${userName}&branchID=${BranchID}`,
      {}
    ),

  GetCusDebtZero: (params) => API_AUTH.get(`khach-hang/get-cong-no-0`, params),
  GetOrderRetailCustomers: (params) =>
    API_AUTH.get(`khach-hang/get-don-hang-khach-le`, params),

  DeleteCusDebtZero: (params) =>
    API_AUTH.post("Role/XoaDuLieuKhachHang", params),
  DeleteRetailCustomers: (params) =>
    API_AUTH.post("Role/XoaDuLieuKhachLe", params),
};

export default PhanQuyenApi;
